import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBox32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconBox32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.658 28.33a3 3 0 0 0 2.684 0l10.276-5.139A2.5 2.5 0 0 0 29 20.955v-9.6a3 3 0 0 0-1.658-2.684L17.118 3.559a2.5 2.5 0 0 0-2.236 0L4.658 8.671A3 3 0 0 0 3 11.354v9.6a2.5 2.5 0 0 0 1.382 2.237zM5.83 21.678A1.5 1.5 0 0 1 5 20.337v-7.91a.5.5 0 0 1 .724-.447l8.447 4.223A1.5 1.5 0 0 1 15 17.545v7.91a.5.5 0 0 1-.724.447zM7.25 9.612a.5.5 0 0 0 0 .894l8.08 4.04a1.5 1.5 0 0 0 1.342 0l8.08-4.04a.5.5 0 0 0 0-.894l-8.08-4.04a1.5 1.5 0 0 0-1.342 0zm19.027 2.368a.5.5 0 0 1 .724.447v7.91a1.5 1.5 0 0 1-.83 1.342l-8.446 4.223a.5.5 0 0 1-.724-.447v-7.91a1.5 1.5 0 0 1 .83-1.342z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBox32);
